import React from 'react';
import PropTypes from 'prop-types';
import { useLikesAndComments, useLoader } from '../../../services/customHooks';
import withCSRF from '../../../commonComponents/withCSRF';
import TimelineContainer from '../../../commonComponents/timeline/TimelineContainer';
import LeadTimelineItem from './LeadTimelineItem';
import GameLeadProp from '../propTypes/gameLeadProp';
import CommentsModal from '../details/timeline/CommentsModal';

function LeadTimeline({ _csrf, lead }) {
  const { data, setData, isLoading } = useLoader(
    `/challenges/leads/${lead._id}/timeline`,
    'error_fetchLeadTimeline',
    [],
    [lead],
  );

  const {
    commentsModal,
    showCommentsModal,
    hideCommentsModal,
    handleAddComment,
    handleAddLike,
  } = useLikesAndComments(setData, _csrf);

  return (
    <>
      {commentsModal.show && (
        <CommentsModal
          eventId={commentsModal.id}
          onClose={hideCommentsModal}
          onAddComment={handleAddComment}
        />
      )}
      <div className="m-portlet__body timeline-container">
        {isLoading ? (
          <div className="loading-indicator" />
        ) : (
          <TimelineContainer>
            {data.map((event, index) => (
              <LeadTimelineItem
                key={event._id}
                side={index % 2 === 0 ? 'left' : 'right'}
                isFirst={index === 0}
                event={event}
                onAddLike={handleAddLike}
                onAddComment={showCommentsModal}
              />
            ))}
          </TimelineContainer>
        )}
      </div>
    </>
  );
}

LeadTimeline.propTypes = {
  _csrf: PropTypes.string.isRequired,
  lead: PropTypes.shape(GameLeadProp.propType).isRequired,
};

export default withCSRF(LeadTimeline);
